import React from 'react';
import buildUrl from 'components/dashboard/buildUrl';
import ImmediateCoachingContainer from 'components/coaching/ImmediateCoachingContainer';

export default function withAdHocPlanDialog(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        showDialog: false,
        rep: null,
        callId: null,
      };
      this.onCoachNow = this.onCoachNow.bind(this);
    }

    onCoachNow({rep, callId}) {
      this.setState({
        showDialog: true,
        rep,
        callId,
        showRepSelect: !rep,
      });
    }

    render() {
      // this can be called with optional filtering on coaching review types.
      // either only show "no call" reviews, or only show reviews where calls are included.
      const {adHocNoCallOnly, includesCallsOnly} = this.props;
      const {showDialog} = this.state;

      const {adminId, managerId, coachId} = this.props;

      // we need to send one of these to get the user to the appropriate
      // dashboard level. Prefer admin obviously, then mgr, then coach
      const adminIdToUse = adminId;

      let managerIdToUse;
      if (adminId) {
        managerIdToUse = adminId === managerId ? managerId : null;
      } else {
        managerIdToUse = managerId;
      }

      const coachIdToUse = managerIdToUse || adminIdToUse ? null : coachId;

      const dashV2Url =
        buildUrl({
          adminId: adminIdToUse,
          managerId: managerIdToUse,
          coachId: coachIdToUse,
        }) + '/coaching-plans';

      return (
        <div className="ad-hoc-dialog-wrapper">
          <WrappedComponent {...this.props} onCoachNow={this.onCoachNow} />
          {showDialog && (
            <ImmediateCoachingContainer
              {...this.props}
              rep={this.props.rep || this.state.rep}
              noCallOnly={adHocNoCallOnly}
              includesCallsOnly={includesCallsOnly}
              dashV2Url={dashV2Url}
              onClose={() => this.setState({showDialog: false})}
            />
          )}
        </div>
      );
    }
  };
}
